// extracted by mini-css-extract-plugin
export default {"master_filter":"TasksFiltersV2_master_filter__Z7KAO"};